<ion-content>
  <div class="py-4">
    <ion-list lines="none">
      <ion-item class="pointer-hover py-1 px-4" (click)="select(2)">
        <div slot="start">
          <div [class.color-primary]="value === 2">
            <i class="fa-kit fa-picto-programme fs-28"></i>
          </div>
        </div>
        <ion-label>
          <div>
            <div class="h5 mb-1">
              {{ 'P00037.dashboard.regulation' | translate }}
            </div>
            <div class="color-medium">
              {{ 'P00037.dashboard.regulationDescription' | translate }}
            </div>
          </div>
        </ion-label>

        @if (value === 2) {
          <div slot="end" class="color-primary">
            <i class="fa-regular fa-check"></i>
          </div>
        }
      </ion-item>
      <ion-item class="pointer-hover py-1 px-4" (click)="select(3)">
        <div slot="start">
          <div [class.color-primary]="value === 3">
            <i class="fa-kit fa-picto-horloge fs-28"></i>
          </div>
        </div>
        <ion-label>
          <div>
            <div class="h5 mb-1">
              {{ 'P00037.dashboard.horloge' | translate }}
            </div>
            <div class="color-medium">
              {{ 'P00037.dashboard.horlogeDescription' | translate }}
            </div>
          </div>
        </ion-label>

        @if (value === 3) {
          <div slot="end" class="color-primary">
            <i class="fa-regular fa-check"></i>
          </div>
        }
      </ion-item>

      @if (removeBoost === false) {
        <ion-item class="pointer-hover py-1 px-4" (click)="select(4)">
          <div slot="start">
            <div [class.color-primary]="value === 4">
              <i class="fa-kit fa-picto-boost24 fs-28"></i>
            </div>
          </div>
          <ion-label>
            <div>
              <div class="h5 mb-1">
                {{ 'P00037.dashboard.boost' | translate }}
              </div>
              <div class="color-medium">
                {{ 'P00037.dashboard.boostDescription' | translate }}
              </div>
            </div>
          </ion-label>

          @if (value === 4) {
            <div slot="end" class="color-primary">
              <i class="fa-regular fa-check"></i>
            </div>
          }
        </ion-item>
      }
    </ion-list>
  </div>
</ion-content>

<ion-footer>
  <div class="p-3">
    <div class="row">
      <div class="col-12 text-center">
        <ion-button
          expand="block"
          fill="outline"
          color="medium"
          (click)="dismissModal()"
        >
          {{ 'selectTimeInterval.cancel' | translate }}
        </ion-button>
      </div>
    </div>
  </div>
</ion-footer>
